module.exports = __webpack_public_path__ + "static/img/系統logo1(更新).8fdf040.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/系統logo1(更新).svg
// module id = Y9Me
// module chunks = 55